import { render, staticRenderFns } from "./provider-detail.vue?vue&type=template&id=266a9717"
import script from "./provider-detail.vue?vue&type=script&lang=js"
export * from "./provider-detail.vue?vue&type=script&lang=js"
import style0 from "./provider-detail.vue?vue&type=style&index=0&id=266a9717&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports